<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.ssn }}
        <br />
        <br />
        {{ creditBureau.address_name }}
        <br />
        {{ creditBureau.street_address }}
        <br />
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
        <br />
        <br />
        Date: {{ date }}
    </p>
    <div class="page">
        <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record')">
            <strong>RE: Account: # {{ creditor.reference_number }}</strong>
            <p class="letter-content">
                I obtained my Experian credit report online. There was a 
                <strong>"{{ creditor.furnisher_name }}"</strong> 
                item listed on my credit report. Per the 
                <strong>FCRA 623(a)(5):</strong> 
                “If the Credit Bureau cannot 
                <strong>VALIDATE</strong> 
                the information with the 
                <strong>ORIGINAL CREDITOR</strong>, 
                they must remove said information from the consumer credit file”.
            </p>
            <p class="letter-content">
                The {{ creditor.court }} has mailed me a letter which emphatically stated that they do 
                <strong>NOT</strong> 
                provide any information to credit reporting agencies, nor did they 
                <strong>EVER</strong> 
                validate and/or confirm public records. 
                It is the credit reporting agencies, and/or other third party providers who collect information regarding public cases from public records. 
                Public records information is <strong>NEVER</strong> 
                validated by the Recorder of Deeds nor the U. S. Court system due to the Fair Credit Reporting Agency 
                <strong>PRIVACY LAW</strong>.
            </p>
            <p class="letter-content">
                My inquiry to the {{ creditor.court }} confirmed 
                <strong>{{ creditBureau.name }}</strong> 
                Credit Bureau has <strong>NEVER</strong> 
                validated or verified this public record entry on my credit report, neither will they ever be by them. 
                They further stated while they are <strong>NOT</strong> 
                liable or responsible for any <strong>MISUSE</strong> or 
                <strong>INCORRECT</strong> public records, nor the distribution of said information, 
                public records may, and oftentimes are, reported by third party sources unawares to the consumer, 
                and in most cases, incorrectly. Considering the information indicating a Fair Credit Reporting Act violation, 
                I need all bankruptcy information currently showing under my social security number to be PERMANENTLY 
                <strong>DELETED</strong> from my credit report immediately.
            </p>
        </template>
        <p class="letter-content">
            The <strong>{{ creditBureau.name }}</strong> 
            Credit Bureau needs to provide me with copies of <strong>all documentation</strong> 
            associated with the Public Record Accounts bearing either a court order to place this information in my credit report, 
            or my authorization of release bearing my signature. In the meantime, to be in full compliance with the FCRA laws and guidelines, 
            all the information listed under <strong>“Public Records”</strong> needs to be <strong>immediately deleted</strong> 
            from the credit file you maintain under my name and social security number. 
            Be further advised that I am closely monitoring my credit file. Per the Federal Law, 
            you have exactly 30 days to complete this investigation as outlined per the <strong>Fair Credit Reporting Act 623(a)(3)</strong>.
        </p>
        <p class="letter-content">
            Per the <strong>Federal Credit Reporting Act, Section 609(a)(1)(a)</strong>, 
            you are required by federal law to verify – through physical verification of the 
            <strong>original signed consumer contract and/or judgment(s)</strong> 
            – all accounts and public information that you post on anyone’s credit report. 
            Otherwise, anyone paying for your reporting services could fax, mail, email in fraudulent and erroneous account information. 
            As such, if this unauthorized public record information is not deleted from my credit report within the next 30 days, 
            I will be filing a complaint to the Federal Trade Commission, Consumer Financial Protection Bureau.
            <br />
            <br />
            Failure to respond in a satisfactory manner within <strong>30 days</strong> 
            of receipt of this certified letter will result in a small claims action against the 
            <strong>{{ creditBureau.name }}</strong> Credit Reporting Bureau. 
            I will be seeking no less than $5,000 in damages for, but not limited to: 
            1) Defamation; 
            2) Negligent Enhancement of Identity Fraud; 
            3) Violation of the Fair Credit Reporting Act and Consumer Financial Protection Bureau. 
            Sincerely,
        </p>
        <p>
            Best Regards,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>